import spotifyIcon from './spotify-icon.png';
import {addCommaToNumber} from './stats';
import React from 'react';
import {TopItem} from "./types";
import {OPEN_SPOTIFY} from "../util/util";
import {EntityModal, EntityType} from "./entity-modal";

// Default values for the dropdowns (must be in the array specified in the props)
const DEFAULT_TRACK_COUNT_LIMIT = 100;
const DEFAULT_ARTIST_COUNT_LIMIT = 50;
const DEFAULT_ALBUM_COUNT_LIMIT = 50;

// Shared Tailwind class strings
const tableBase = 'text-mm-text w-4/5 portrait:w-[95%] mx-auto mb-4 border-collapse';
const tableArtist = 'text-mm-text w-1/2 portrait:w-[90%] mx-auto mb-4 border-collapse';
const thClass = 'text-left py-[0.62rem] px-2 border-b border-mm-gray';
const tdClass = 'py-[0.62rem] px-2 portrait:px-1';
const trClass = 'border-b border-mm-gray';
const headTrClass = 'text-mm-cyan';

export interface TopTableStyleProps {
    defaultCount: number;
    ddValues: number[];
    tableStyle: string;
    head_horiz: React.ReactElement;
    head_vert: React.ReactElement;
    row_horiz: (item: TopItem) => React.ReactElement;
    row_vert: (item: TopItem) => React.ReactElement;
}

export const trackCountProps: TopTableStyleProps = {
    defaultCount: DEFAULT_TRACK_COUNT_LIMIT,
    ddValues: [25, 50, 100, 250],
    tableStyle: tableBase,
    head_horiz: (
        <thead>
        <tr className={headTrClass}>
            <th className={thClass} style={{width: '5%'}}></th>
            <th className={thClass} style={{width: '5%'}}>#</th>
            <th className={thClass} style={{width: '5%'}}></th>
            <th className={thClass} style={{width: '40%'}}>Track</th>
            <th className={thClass} style={{width: '40%'}}>Artist</th>
            <th className={thClass} style={{textAlign: 'right', width: '5%'}}>Listens</th>
        </tr>
        </thead>
    ),
    head_vert: (
        <thead>
        <tr className={headTrClass}>
            <th className={thClass}></th>
            <th className={thClass}>#</th>
            <th className={thClass}></th>
            <th className={thClass}>Track</th>
            <th className={thClass} style={{textAlign: 'right'}}>Listens</th>
        </tr>
        </thead>
    ),
    row_horiz: (item: TopItem) => {
        return (
            <tr className={trClass} key={item.trackId}>
                <td className={tdClass}><a href={OPEN_SPOTIFY + '/track/' + item.trackId} target={'_blank'} rel={'noreferrer'}><img src={spotifyIcon} alt={'Spotify'} style={{width: '1.5rem'}}/></a></td>
                <td className={tdClass}>{item.rank}</td>
                <td className={tdClass}><img src={item.image} style={{width: '3rem'}} alt={'Unavailable'}/></td>
                <td className={tdClass + ' cursor-pointer'} onClick={() => item.setEntityModal(
                    <EntityModal id={item.trackId} image={item.image} entityType={EntityType.Track} name={item.track} closeCallback={() => item.setEntityModal(undefined)} />
                )}>{item.track}</td>
                <td className={tdClass}><LinkedArtistList names={item.artists} ids={item.artistIds} setEntityModal={item.setEntityModal}/></td>
                <td className={tdClass} style={{textAlign: 'right'}}>{addCommaToNumber(item.count)}</td>
            </tr>
        );
    },
    row_vert: (item: TopItem) => {
        return (
            <tr className={trClass} key={item.trackId}>
                <td className={tdClass}><a href={OPEN_SPOTIFY + '/track/' + item.trackId} target={'_blank'} rel={'noreferrer'}><img src={spotifyIcon} alt={'Unavailable'} style={{width: '1.5rem'}}/></a></td>
                <td className={tdClass}>{item.rank}</td>
                <td className={tdClass}><img src={item.image} style={{width: '3rem'}} alt={'Unavailable'}/></td>
                <td className={tdClass}>
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                        <div onClick={() => item.setEntityModal(
                            <EntityModal id={item.trackId} image={item.image} entityType={EntityType.Track} name={item.track} closeCallback={() => item.setEntityModal(undefined)} />
                        )} style={{cursor: 'pointer'}}><b>{item.track}</b></div>
                        <LinkedArtistList names={item.artists} ids={item.artistIds} setEntityModal={item.setEntityModal}/>
                    </div>
                </td>
                <td className={tdClass} style={{textAlign: 'right'}}>{addCommaToNumber(item.count)}</td>
            </tr>
        );
    }
}
export const trackTimeProps: TopTableStyleProps = {
    defaultCount: DEFAULT_TRACK_COUNT_LIMIT,
    ddValues: [25, 50, 100, 250],
    tableStyle: tableBase,
    head_horiz: (
        <thead>
        <tr className={headTrClass}>
            <th className={thClass} style={{width: '5%'}}></th>
            <th className={thClass} style={{width: '5%'}}>#</th>
            <th className={thClass} style={{width: '5%'}}></th>
            <th className={thClass} style={{width: '40%'}}>Track</th>
            <th className={thClass} style={{width: '40%'}}>Artist</th>
            <th className={thClass} style={{textAlign: 'right', width: '5%'}}>Minutes</th>
        </tr>
        </thead>
    ),
    head_vert: (
        <thead>
        <tr className={headTrClass}>
            <th className={thClass}></th>
            <th className={thClass}>#</th>
            <th className={thClass}></th>
            <th className={thClass}>Track</th>
            <th className={thClass} style={{textAlign: 'right'}}>Minutes</th>
        </tr>
        </thead>
    ),
    row_horiz: (item: TopItem) => {
        return (
            <tr className={trClass} key={item.trackId}>
                <td className={tdClass}><a href={OPEN_SPOTIFY + '/track/' + item.trackId} target={'_blank'} rel={'noreferrer'}><img src={spotifyIcon} alt={'Unavailable'} style={{width: '1.5rem'}}/></a></td>
                <td className={tdClass}>{item.rank}</td>
                <td className={tdClass}><img src={item.image} style={{width: '3rem'}} alt={'Unavailable'}/></td>
                <td className={tdClass + ' cursor-pointer'} onClick={() => item.setEntityModal(
                    <EntityModal id={item.trackId} image={item.image} entityType={EntityType.Track} name={item.track} closeCallback={() => item.setEntityModal(undefined)} />
                )}>{item.track}</td>
                <td className={tdClass}><LinkedArtistList names={item.artists} ids={item.artistIds} setEntityModal={item.setEntityModal}/></td>
                <td className={tdClass} style={{textAlign: 'right'}}>{addCommaToNumber(Math.round(item.count/60))}</td>
            </tr>
        );
    },
    row_vert: (item: TopItem) => {
        return (
            <tr className={trClass} key={item.trackId}>
                <td className={tdClass}><a href={OPEN_SPOTIFY + '/track/' + item.trackId} target={'_blank'} rel={'noreferrer'}><img src={spotifyIcon} alt={'Unavailable'} style={{width: '1.5rem'}}/></a></td>
                <td className={tdClass}>{item.rank}</td>
                <td className={tdClass}><img src={item.image} style={{width: '3rem'}} alt={'Unavailable'}/></td>
                <td className={tdClass}>
                    <div>
                        <div onClick={() => item.setEntityModal(
                            <EntityModal id={item.trackId} image={item.image} entityType={EntityType.Track} name={item.track} closeCallback={() => item.setEntityModal(undefined)} />
                        )} style={{cursor: 'pointer'}}>{item.track}</div>
                        <LinkedArtistList names={item.artists} ids={item.artistIds} setEntityModal={item.setEntityModal}/>
                    </div>
                </td>
                <td className={tdClass} style={{textAlign: 'right'}}>{addCommaToNumber(Math.round(item.count/60))}</td>
            </tr>
        );
    }
}
export const artistCountProps: TopTableStyleProps = {
    defaultCount: DEFAULT_ARTIST_COUNT_LIMIT,
    ddValues: [10, 25, 50, 100],
    tableStyle: tableArtist,
    head_horiz: (
        <thead>
        <tr className={headTrClass}>
            <th className={thClass} style={{width: '5%'}}></th>
            <th className={thClass} style={{width: '15%'}}>#</th>
            <th className={thClass} style={{width: '75%'}}>Artist</th>
            <th className={thClass} style={{textAlign: 'right', width: '5%'}}>Listens</th>
        </tr>
        </thead>
    ),
    head_vert: (
        <thead>
        <tr className={headTrClass}>
            <th className={thClass} style={{width: '5%'}}></th>
            <th className={thClass} style={{width: '15%'}}>#</th>
            <th className={thClass} style={{width: '75%'}}>Artist</th>
            <th className={thClass} style={{textAlign: 'right', width: '5%'}}>Listens</th>
        </tr>
        </thead>
    ),
    row_horiz: (item: TopItem) => {
        let artistId = item.artistId;
        let artist = item.artist;
        return (
            <tr className={trClass} key={artistId}>
                <td className={tdClass}><a href={OPEN_SPOTIFY + '/artist/' + artistId} target={'_blank'} rel={'noreferrer'}><img src={spotifyIcon} alt={'Unavailable'} style={{width: '1.5rem'}}/></a></td>
                <td className={tdClass}>{item.rank}</td>
                <td className={tdClass + ' cursor-pointer'} onClick={() => item.setEntityModal(
                    <EntityModal id={item.artistId} entityType={EntityType.Artist} image={''} name={item.artist} closeCallback={() => item.setEntityModal(undefined)} />
                )}>{artist}</td>
                <td className={tdClass} style={{textAlign: 'right'}}>{addCommaToNumber(item.count)}</td>
            </tr>
        );
    },
    row_vert: (item: TopItem) => {
        let artistId = item.artistId;
        let artist = item.artist;
        return (
            <tr className={trClass} key={artistId}>
                <td className={tdClass}><a href={OPEN_SPOTIFY + '/artist/' + artistId} target={'_blank'} rel={'noreferrer'}><img src={spotifyIcon} alt={'Unavailable'} style={{width: '1.5rem'}}/></a></td>
                <td className={tdClass}>{item.rank}</td>
                <td className={tdClass + ' cursor-pointer'} onClick={() => item.setEntityModal(
                    <EntityModal id={item.artistId} entityType={EntityType.Artist} image={''} name={item.artist} closeCallback={() => item.setEntityModal(undefined)} />
                )}>{artist}</td>
                <td className={tdClass} style={{textAlign: 'right'}}>{addCommaToNumber(item.count)}</td>
            </tr>
        );
    }
}
export const artistTimeProps: TopTableStyleProps = {
    defaultCount: DEFAULT_ARTIST_COUNT_LIMIT,
    ddValues: [10, 25, 50, 100],
    tableStyle: tableArtist,
    head_horiz: (
        <thead>
        <tr className={headTrClass}>
            <th className={thClass} style={{width: '5%'}}></th>
            <th className={thClass} style={{width: '15%'}}>#</th>
            <th className={thClass} style={{width: '75%'}}>Artist</th>
            <th className={thClass} style={{textAlign: 'right', width: '5%'}}>Minutes</th>
        </tr>
        </thead>
    ),
    head_vert: (
        <thead>
        <tr className={headTrClass}>
            <th className={thClass} style={{width: '5%'}}></th>
            <th className={thClass} style={{width: '15%'}}>#</th>
            <th className={thClass} style={{width: '75%'}}>Artist</th>
            <th className={thClass} style={{textAlign: 'right', width: '5%'}}>Minutes</th>
        </tr>
        </thead>
    ),
    row_horiz: (item: TopItem) => {
        let artistId = item.artistId;
        let artist = item.artist;
        return (
            <tr className={trClass} key={artistId}>
                <td className={tdClass}><a href={OPEN_SPOTIFY + '/artist/' + artistId} target={'_blank'} rel={'noreferrer'}><img src={spotifyIcon} alt={'Unavailable'} style={{width: '1.5rem'}}/></a></td>
                <td className={tdClass}>{item.rank}</td>
                <td className={tdClass + ' cursor-pointer'} onClick={() => item.setEntityModal(
                    <EntityModal id={item.artistId} entityType={EntityType.Artist} image={''} name={item.artist} closeCallback={() => item.setEntityModal(undefined)} />
                )}>{artist}</td>
                <td className={tdClass} style={{textAlign: 'right'}}>{addCommaToNumber(Math.round(item.count/60))}</td>
            </tr>
        );
    },
    row_vert: (item: TopItem) => {
        let artistId = item.artistId;
        let artist = item.artist;
        return (
            <tr className={trClass} key={artistId}>
                <td className={tdClass}><a href={OPEN_SPOTIFY + '/artist/' + artistId} target={'_blank'} rel={'noreferrer'}><img src={spotifyIcon} alt={'Unavailable'} style={{width: '1.5rem'}}/></a></td>
                <td className={tdClass}>{item.rank}</td>
                <td className={tdClass + ' cursor-pointer'} onClick={() => item.setEntityModal(
                    <EntityModal id={item.artistId} entityType={EntityType.Artist} image={''} name={item.artist} closeCallback={() => item.setEntityModal(undefined)} />
                )}>{artist}</td>
                <td className={tdClass} style={{textAlign: 'right'}}>{addCommaToNumber(Math.round(item.count/60))}</td>
            </tr>
        );
    }
}
export const albumCountProps: TopTableStyleProps = {
    defaultCount: DEFAULT_ALBUM_COUNT_LIMIT,
    ddValues: [10, 25, 50, 100],
    tableStyle: tableBase,
    head_horiz: (
        <thead>
        <tr className={headTrClass}>
            <th className={thClass} style={{width: '5%'}}></th>
            <th className={thClass} style={{width: '5%'}}>#</th>
            <th className={thClass} style={{width: '5%'}}></th>
            <th className={thClass} style={{width: '40%'}}>Album</th>
            <th className={thClass} style={{width: '40%'}}>Artist</th>
            <th className={thClass} style={{textAlign: 'right', width: '5%'}}>Listens</th>
        </tr>
        </thead>
    ),
    head_vert: (
        <thead>
        <tr className={headTrClass}>
            <th className={thClass}></th>
            <th className={thClass}>#</th>
            <th className={thClass}></th>
            <th className={thClass}>Album</th>
            <th className={thClass} style={{textAlign: 'right'}}>Listens</th>
        </tr>
        </thead>
    ),
    row_horiz: (item: TopItem) => {
        return (
            <tr className={trClass} key={item.albumId}>
                <td className={tdClass}><a href={OPEN_SPOTIFY + '/album/' + item.albumId} target={'_blank'} rel={'noreferrer'}><img src={spotifyIcon} alt={'Unavailable'} style={{width: '1.5rem'}}/></a></td>
                <td className={tdClass}>{item.rank}</td>
                <td className={tdClass}><img src={item.image} style={{width: '3rem'}} alt={'Unavailable'}/></td>
                <td className={tdClass + ' cursor-pointer'} onClick={() => item.setEntityModal(
                    <EntityModal id={item.albumId} entityType={EntityType.Album} image={item.image} name={item.album} closeCallback={() => item.setEntityModal(undefined)} />
                )}>{item.album}</td>
                <td className={tdClass}><LinkedArtistList names={item.artists} ids={item.artistIds} setEntityModal={item.setEntityModal}/></td>
                <td className={tdClass} style={{textAlign: 'right'}}>{addCommaToNumber(item.count)}</td>
            </tr>
        );
    },
    row_vert: (item: TopItem) => {
        return (
            <tr className={trClass} key={item.albumId}>
                <td className={tdClass}><a href={OPEN_SPOTIFY + '/album/' + item.albumId} target={'_blank'} rel={'noreferrer'}><img src={spotifyIcon} alt={'Unavailable'} style={{width: '1.5rem'}}/></a></td>
                <td className={tdClass}>{item.rank}</td>
                <td className={tdClass}><img src={item.image} style={{width: '3rem'}} alt={'Unavailable'}/></td>
                <td className={tdClass}>
                    <div>
                        <div onClick={() => item.setEntityModal(
                            <EntityModal id={item.albumId} entityType={EntityType.Album} image={item.image} name={item.album} closeCallback={() => item.setEntityModal(undefined)} />
                        )} style={{cursor: 'pointer'}}>{item.album}</div>
                        <LinkedArtistList names={item.artists} ids={item.artistIds} setEntityModal={item.setEntityModal}/>
                    </div>
                </td>
                <td className={tdClass} style={{textAlign: 'right'}}>{addCommaToNumber(item.count)}</td>
            </tr>
        );
    }
}
export const albumTimeProps: TopTableStyleProps = {
    defaultCount: DEFAULT_ALBUM_COUNT_LIMIT,
    ddValues: [10, 25, 50, 100],
    tableStyle: tableBase,
    head_horiz: (
        <thead>
        <tr className={headTrClass}>
            <th className={thClass} style={{width: '5%'}}></th>
            <th className={thClass} style={{width: '5%'}}>#</th>
            <th className={thClass} style={{width: '5%'}}></th>
            <th className={thClass} style={{width: '40%'}}>Album</th>
            <th className={thClass} style={{width: '40%'}}>Artist</th>
            <th className={thClass} style={{textAlign: 'right', width: '5%'}}>Minutes</th>
        </tr>
        </thead>
    ),
    head_vert: (
        <thead>
        <tr className={headTrClass}>
            <th className={thClass}></th>
            <th className={thClass}>#</th>
            <th className={thClass}></th>
            <th className={thClass}>Album</th>
            <th className={thClass} style={{textAlign: 'right'}}>Minutes</th>
        </tr>
        </thead>
    ),
    row_horiz: (item: TopItem) => {
        return (
            <tr className={trClass} key={item.albumId}>
                <td className={tdClass}><a href={OPEN_SPOTIFY + '/album/' + item.albumId} target={'_blank'} rel={'noreferrer'}><img src={spotifyIcon} alt={'Unavailable'} style={{width: '1.5rem'}}/></a></td>
                <td className={tdClass}>{item.rank}</td>
                <td className={tdClass}><img src={item.image} style={{width: '3rem'}} alt={'Unavailable'}/></td>
                <td className={tdClass + ' cursor-pointer'} onClick={() => item.setEntityModal(
                    <EntityModal id={item.albumId} entityType={EntityType.Album} image={item.image} name={item.album} closeCallback={() => item.setEntityModal(undefined)} />
                )}>{item.album}</td>
                <td className={tdClass}><LinkedArtistList names={item.artists} ids={item.artistIds} setEntityModal={item.setEntityModal}/></td>
                <td className={tdClass} style={{textAlign: 'right'}}>{addCommaToNumber(Math.round(item.count/60))}</td>
            </tr>
        );
    },
    row_vert: (item: TopItem) => {
        return (
            <tr className={trClass} key={item.albumId}>
                <td className={tdClass}><a href={OPEN_SPOTIFY + '/album/' + item.albumId} target={'_blank'} rel={'noreferrer'}><img src={spotifyIcon} alt={'Unavailable'} style={{width: '1.5rem'}}/></a></td>
                <td className={tdClass}>{item.rank}</td>
                <td className={tdClass}><img src={item.image} style={{width: '3rem'}} alt={'Unavailable'}/></td>
                <td className={tdClass}>
                    <div>
                        <div onClick={() => item.setEntityModal(
                            <EntityModal id={item.albumId} entityType={EntityType.Album} image={item.image} name={item.album} closeCallback={() => item.setEntityModal(undefined)} />
                        )} style={{cursor: 'pointer'}}>{item.album}</div>
                        <LinkedArtistList names={item.artists} ids={item.artistIds} setEntityModal={item.setEntityModal}/>
                    </div>
                </td>
                <td className={tdClass} style={{textAlign: 'right'}}>{addCommaToNumber(Math.round(item.count/60))}</td>
            </tr>
        );
    }
}

interface LinkedArtistListProps {
    names: string[],
    ids: string[],
    setEntityModal: (data: React.ReactElement | undefined) => void,
}

const LinkedArtistList = (props: LinkedArtistListProps) => {
    if (props === undefined || props.names.length === 0 || props.ids.length === 0) {
        return null;
    }
    const names = props.names;
    const ids = props.ids;

    return (
        <div style={{display: 'flex', flexDirection: 'row'}}>
            {names.map((name, index) => (
                <div key={index} onClick={() => props.setEntityModal(
                    <EntityModal id={ids[index]} entityType={EntityType.Artist} image={''} name={name} closeCallback={() => props.setEntityModal(undefined)}/>
                )} style={{cursor: 'pointer', marginRight: '.3rem'}}>{name}{index === names.length - 1 ? '': ', '}</div>
            ))}
        </div>
    );
}
